import React from 'react';
import PropTypes from 'prop-types';
import { getPhoneNumber } from '../../utils/index';

const EstimateModeFooter = ({ originMODE }) => {
  const phoneNumber = getPhoneNumber(originMODE);

  return (
    <div className="ir-footer">
      <div className="ir-footer-bar">
        <div className="estimate-builder-container">
          <div className="slogan">How doers get more done &trade;</div>
          <div className="help-msg">
            <span>Need help with custom blinds? </span>
            <span className="help-msg-phone">
              Please call us at: <a href={`tel:${phoneNumber}`}><strong>{phoneNumber}</strong></a>
            </span>
          </div>
        </div>
      </div>
      <div className="ir-footer-bottom">
        <div className="estimate-builder-container">
          You are currently shopping custom blinds.
          <a href="http://homedepot.com">Click here to shop all Home Depot products.</a>
        </div>
      </div>
    </div>
  );
};

EstimateModeFooter.propTypes = {
  originMODE: PropTypes.string.isRequired,
};

export default EstimateModeFooter;

